<template>
	<span class="inline-block size-2 min-w-2 rounded-full" :style="{backgroundColor: availability.color}" />
</template>

<script setup lang="ts">
	import type {ProductAvailability} from '~/utils/productAvailability';

	type Props = {
		availability: ProductAvailability;
	};

	defineProps<Props>();
</script>
